import { BehaviorSubject } from "rxjs";
import CookieStorage from "../../../utils/CookieStorage";
import { SELECTED_HOSPITAL_STATE } from "../types/CommonTypes";

export const initialHospitalSelectionState: SELECTED_HOSPITAL_STATE = {};

const hospitalSelectionState$ = new BehaviorSubject<SELECTED_HOSPITAL_STATE>(
  initialHospitalSelectionState
);

CookieStorage.init("hospitalSelectionState", hospitalSelectionState$);

export default hospitalSelectionState$;
